import useSiteData from '../../hooks/siteData';

export function getCwsUrl() {
    const { home } = useSiteData();
    return home.startsWith('https') ? home : 'https://nanoporetech.com';
}

export function getAbsoluteUrl(urlOrPath) {
    if (urlOrPath.startsWith('http')) return urlOrPath;

    let path = urlOrPath;
    if (!path.startsWith('/')) path = '/' + path;
    const baseUrl = getCwsUrl();
    return baseUrl + path;
}

export function getResolvedStoryblokUrl(storyblokLink) {
    if (storyblokLink.url) return getAbsoluteUrl(storyblokLink.url);
    if (storyblokLink.cached_url) return getAbsoluteUrl(storyblokLink.cached_url);

    return '#';
}

// Hook-safe Storyblok link resolver. `useSiteData()` is called unconditionally at
// the top of the calling component; the returned function is a pure resolver that
// can be used inside loops/branches without breaking the rules of hooks. Returns
// `null` when the link has no destination so callers can distinguish "no link".
export function useStoryblokHref() {
    const { home } = useSiteData();
    const base = home.startsWith('https') ? home : 'https://nanoporetech.com';

    return (storyblokLink) => {
        const raw = storyblokLink?.url || storyblokLink?.cached_url;
        if (!raw) return null;
        if (raw.startsWith('http')) return raw;
        const path = raw.startsWith('/') ? raw : '/' + raw;
        return base + path;
    };
}
